import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Logo from './Logo';

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <Link to="/" className="flex items-center gap-2 text-[#A1A1AA] hover:text-white mb-8 text-sm transition-colors">
          <ArrowLeft className="w-4 h-4" /> {t('legal.backToHome')}
        </Link>

        <div className="flex items-center gap-3 mb-8">
          <Logo size={40} />
          <h1 className="font-['Outfit'] text-3xl font-medium">{t('legal.privacyTitle')}</h1>
        </div>

        <div
          className="prose prose-invert max-w-none space-y-6 text-[#A1A1AA] text-sm leading-relaxed"
          data-testid="privacy-policy-content"
          dangerouslySetInnerHTML={{ __html: t('legal.privacyBody') }}
        />
      </div>
    </div>
  );
};

export default PrivacyPolicy;
